import { format } from 'date-fns'
import { ko } from 'date-fns/locale'

import { CopyButton, formatCurrency } from '@/shared/lib'
import { Icon, Description } from '@/shared/ui'

import { DeadlineTimer } from './deadline-timer'

export type Props = {
  payDeadlineTime: string
  vaBankName: string
  vaAccountHolder: string
  vaAccount: string
  finalPayFee: number
}

const DATE_TIME_FORMAT = 'yyyy년 MM월 dd일 a h:mm'
const COPY_SUCCESS_MESSAGE = '계좌번호가 복사되었습니다.'

export const AccountPayment = ({
  payDeadlineTime,
  vaBankName,
  vaAccountHolder,
  vaAccount,
  finalPayFee,
}: Props) => {
  const account = `${vaBankName} ${vaAccount}`

  const formattedPayDeadlineTime = format(
    new Date(payDeadlineTime),
    DATE_TIME_FORMAT,
    { locale: ko },
  )

  return (
    <div className="space-y-6">
      <p className="typo-body1-reading text-center font-semibold text-black">
        <span className="text-purple-500">이체 완료 순서</span>에 따라 계약이
        우선 확정됩니다.
      </p>

      <div className="rounded-sm shadow-[0px_0px_4px_0px_rgba(0,0,0,0.18)]">
        <div className="flex flex-col items-center justify-center gap-2 bg-gray-50 px-3 py-4 text-center">
          <div className="typo-label1 flex items-center gap-1">
            <Icon name="clock" size={18} className="text-black" />
            <span className="font-medium text-black">결제 마감까지</span>
            <DeadlineTimer deadline={payDeadlineTime} />
          </div>
          <p className="typo-label2 font-normal text-gray-900">
            {formattedPayDeadlineTime}까지 결제해 주세요
          </p>
        </div>

        <div className="p-6">
          <Description.List>
            <Description.Item className="justify-between">
              <Description.ItemLabel>계좌번호</Description.ItemLabel>
              <Description.ItemValue className="flex items-center gap-2">
                <span>{account}</span>
                <CopyButton
                  value={account}
                  successMessage={COPY_SUCCESS_MESSAGE}
                />
              </Description.ItemValue>
            </Description.Item>

            <Description.Item
              className="justify-between"
              label="예금주"
              value={vaAccountHolder}
            />

            <Description.Item className="justify-between">
              <Description.ItemLabel className="self-start">
                결제금액
              </Description.ItemLabel>
              <Description.ItemValue className="flex flex-col items-end gap-1">
                <span className="typo-body1 font-bold text-gray-900">
                  {formatCurrency(finalPayFee)}원
                </span>
                <span className="typo-label2 font-normal text-gray-500">
                  정확한 금액을 이체해 주세요.
                </span>
              </Description.ItemValue>
            </Description.Item>
          </Description.List>
        </div>
      </div>
    </div>
  )
}
